const GoOnTop = () => import('./GoOnTop')

export default function installComponents(Vue) {
  Vue.component('GoOnTop', GoOnTop)
}
